import { debug } from "../utils";

export const ACTION_TOAST_CHANGED = "ACTION_TOAST_CHANGED";


export function ToastReducer(state = {}, action) {
    switch (action.type) {
        case ACTION_TOAST_CHANGED: {
            debug(`ToastReducer ${ACTION_TOAST_CHANGED} is being processed...`)
            return action.payload;
        }
        default:
            return state;
    }
}
